import BriefcaseIcon from "@heroicons/react/24/solid/BriefcaseIcon";
import { styled as styling } from "@mui/material/styles";
import Link from "next/link";
import Color from "../../../assets/colors";

export const LinkWrapper = styling(Link)({
  textDecoration: "none",
  color: Color.black,
  width: "100%",
  minWidth: 0,
});

export const Wrapper = styling("div")({
  borderRadius: "0.625rem",
  boxShadow: "0px 2px 5px 0px rgba(0,0,0,0.2)",
  height: "100%",
  width: "100%",
  minWidth: 0,
  overflow: "hidden",
  display: "flex",
  flexDirection: "column",
  transition: "all 0.15s ease-in-out",
  ":hover": {
    cursor: "pointer",
    boxShadow: "0 0 0 2px rgba(0,0,0,0.35)",
  },
});

export const ImageContainer = styling("div")({
  position: "relative",

  borderRadius: "0.625rem",

  height: "240px",
  overflow: "clip",
});

export const CompanyDetailsContainer = styling("div")({
  display: "flex",
  flexDirection: "column",
  gap: "0.25rem",
  padding: "1.5rem 1rem",
  flex: 1,
  minWidth: 0,
});

export const CompanyName = styling("h2")({
  color: Color.textHighEmphasis,

  fontWeight: "600",
  fontSize: "1rem",
  lineHeight: "24px",

  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  overflow: "hidden",

  flex: "0 1 auto",
  minWidth: 0,
  margin: "0",

  "@media (max-width: 640px)": {
    display: "-webkit-box",
    WebkitLineClamp: 2,
    WebkitBoxOrient: "vertical",
    whiteSpace: "normal",
    overflowWrap: "anywhere",
    wordBreak: "break-word",
  },
});

export const CompanyIndustry = styling("h3")({
  color: Color.textMediumEmphasis,

  fontWeight: "500",
  fontSize: "0.875rem",
  lineHeight: "1.25rem",

  margin: "0",
});

export const JobCount = styling("h4")({
  color: Color.textMediumEmphasis,

  display: "flex",
  alignItems: "center",
  gap: "0.25rem",

  fontWeight: "500",
  fontSize: "0.875rem",
  lineHeight: "1.25rem",

  margin: "0",
});

export const CompanyImageBanner = styling("img")({
  width: "100%",
  height: "240px",
  objectFit: "cover",
});

export const CompanyLogo = styling("img")((props) => ({
  position: "absolute",
  bottom: "-5px",
  right: "-5px",
  zIndex: 1,

  backgroundColor: Color.white,
  border: `5px solid ${Color.white}`,
  borderRadius: "0.625rem 0 0 0",

  width: "90px",
  height: "90px",
  objectFit: props.$placeholder ? "fit" : "contain",
}));

export const JobIconStyled = styling(BriefcaseIcon)({
  height: "16px",
  width: "16px",
});
